import { render, staticRenderFns } from "./formArticleList.vue?vue&type=template&id=6d3c36da&scoped=true&"
import script from "./formArticleList.vue?vue&type=script&lang=js&"
export * from "./formArticleList.vue?vue&type=script&lang=js&"
import style0 from "./formArticleList.vue?vue&type=style&index=0&id=6d3c36da&lang=scss&scoped=true&"
import style1 from "./formArticleList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c36da",
  null
  
)

export default component.exports